// Depends on jsbn.js and rng.js
//const BigInteger = require("./jsbn.js");
import BigInteger from './jsbn';
import SecureRandom from './rng';
//var SecureRandom = require("./rng");
var NodeRSA = require("node-rsa");
// Version 1.1: support utf-8 encoding in pkcs1pad2

// convert a (hex) string to a bignum object
function parseBigInt(str, r) {
  return new BigInteger(str, r);
}

function linebrk(s, n) {
  var ret = "";
  var i = 0;
  while (i + n < s.length) {
    ret += s.substring(i, i + n) + "\n";
    i += n;
  }
  return ret + s.substring(i, s.length);
}

function byte2Hex(b) {
  if (b < 0x10) return "0" + b.toString(16);
  else return b.toString(16);
}

// PKCS#1 (type 2, random) pad input string s to n bytes, and return a bigint
function pkcs1pad2(s, n) {
  if (n < s.length + 11) {
    // TODO: fix for utf-8
    //console.log("Message too long for RSA");
    return null;
  }
  var ba = new Array();
  var i = s.length - 1;
  while (i >= 0 && n > 0) {
    var c = s.charCodeAt(i--);
    if (c < 128) {
      // encode using utf-8
      ba[--n] = c;
    } else if (c > 127 && c < 2048) {
      ba[--n] = (c & 63) | 128;
      ba[--n] = (c >> 6) | 192;
    } else {
      ba[--n] = (c & 63) | 128;
      ba[--n] = ((c >> 6) & 63) | 128;
      ba[--n] = (c >> 12) | 224;
    }
  }
  ba[--n] = 0;
  var rng = new SecureRandom();
  var x = new Array();
  while (n > 2) {
    // random non-zero pad
    x[0] = 0;
    while (x[0] == 0) rng.nextBytes(x);
    ba[--n] = x[0];
  }
  ba[--n] = 2;
  ba[--n] = 0;
  return new BigInteger(ba);
}

// "empty" RSA key constructor
function RSAKey() {
  this.n = null; // modulus
  this.e = 0; // public exponent
  this.d = null; // private exponent
  this.p = null; // prime 1
  this.q = null; // prime 2
  this.dmp1 = null; // exponent1
  this.dmq1 = null; // exponent2
  this.coeff = null; // coefficient
}

// return modulus and public exponent as string
function RSAGetPublicString() {
  var exportObj = { n: this.n.toString(16), e: this.e.toString(16) };
  if (exportObj.n.length % 2 == 1) {
    exportObj.n = "0" + exportObj.n; // pad them with 0
  }
  return JSON.stringify(exportObj);
}

function RSAGetPrivateString() {
  var privateKeys = ["n", "e", "d", "p", "q", "dmp1", "dmq1", "coeff"];
  var ret = {};
  var that = this;
  privateKeys.forEach(function(key) {
    ret[key] = that[key] && that[key].toString(16);
    if (key != "e" && ret[key].length % 2 == 1) {
      ret[key] = "0" + ret[key];
    }
  });

  return JSON.stringify(ret);
}

function RSASetPrivateString(privateStr) {
  var privateObj = JSON.parse(privateStr);
  return this.setPrivateEx(privateObj);
}

// Set the public key fields N and e from hex strings
function RSASetPublic(N, E) {
  if (N != null && E != null && N.length > 0 && E.length > 0) {
    this.n = parseBigInt(N, 16);
    this.e = parseInt(E, 16);
  } else console.log("Invalid RSA public key");
}

function RSASetPublicString(publicStr) {
  var publicObj = JSON.parse(publicStr);
  return this.setPublic(publicObj.n, publicObj.e);
}

function RSASetPublicCert(cert) {
  var key = new NodeRSA();
  key.importKey(cert, "pkcs8-public");

  var exportObj = {
    n: key.keyPair.n.toString(16),
    e: key.keyPair.e.toString(16)
  };
  if (exportObj.n.length % 2 == 1) {
    exportObj.n = "0" + exportObj.n; // pad them with 0
  }
  return this.setPublic(exportObj.n, exportObj.e);
}

// Perform raw public operation on "x": return x^e (mod n)
function RSADoPublic(x) {
  return x.modPowInt(this.e, this.n);
}

// Return the PKCS#1 RSA encryption of "text" as an even-length hex string
function RSAEncrypt(text) {
  var m = pkcs1pad2(text, (this.n.bitLength() + 7) >> 3);
  if (m == null) return null;
  var c = this.doPublic(m);
  if (c == null) return null;
  var h = c.toString(16);
  if ((h.length & 1) == 0) return h;
  else return "0" + h;
}

// Return the PKCS#1 RSA encryption of "text" as an even-length hex string
function RSAEncryptPrivate(text) {
  var m = pkcs1pad2(text, (this.n.bitLength() + 7) >> 3);
  if (m == null) return null;
  var c = this.doPrivate(m);
  if (c == null) return null;
  var h = c.toString(16);
  if ((h.length & 1) == 0) return h;
  else return "0" + h;
}

// Return the PKCS#1 RSA encryption of "text" as a Base64-encoded string
function RSAEncryptB64(text) {
  var h = this.encrypt(text);
  if (h) return hex2b64(h);
  else return null;
}

function hex2b64(h) {
  var b64map =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
  var b64pad = "=";

  var i;
  var c;
  var ret = "";
  for (i = 0; i + 3 <= h.length; i += 3) {
    c = parseInt(h.substring(i, i + 3), 16);
    ret += b64map.charAt(c >> 6) + b64map.charAt(c & 63);
  }
  if (i + 1 == h.length) {
    c = parseInt(h.substring(i, i + 1), 16);
    ret += b64map.charAt(c << 2);
  } else if (i + 2 == h.length) {
    c = parseInt(h.substring(i, i + 2), 16);
    ret += b64map.charAt(c >> 2) + b64map.charAt((c & 3) << 4);
  }
  while ((ret.length & 3) > 0) ret += b64pad;
  return ret;
}

// protected
RSAKey.prototype.doPublic = RSADoPublic;

// public
RSAKey.prototype.setPublic = RSASetPublic;
RSAKey.prototype.encrypt = RSAEncrypt;
RSAKey.prototype.encryptPrivate = RSAEncryptPrivate;
RSAKey.prototype.encrypt_b64 = RSAEncryptB64;

// Start rsa2.js
// Depends on rsa.js and jsbn2.js

// Version 1.1: support utf-8 decoding in pkcs1unpad2

// Undo PKCS#1 (type 2, random) padding and, if valid, return the plaintext
function pkcs1unpad2(d, n) {
  var b = d.toByteArray();
  var i = 0;
  while (i < b.length && b[i] == 0) ++i;
  if (b.length - i != n - 1 || b[i] != 2) return null;
  ++i;
  while (b[i] != 0) if (++i >= b.length) return null;
  var ret = "";
  while (++i < b.length) {
    var c = b[i] & 255;
    if (c < 128) {
      // utf-8 decode
      ret += String.fromCharCode(c);
    } else if (c > 191 && c < 224) {
      ret += String.fromCharCode(((c & 31) << 6) | (b[i + 1] & 63));
      ++i;
    } else {
      ret += String.fromCharCode(
        ((c & 15) << 12) | ((b[i + 1] & 63) << 6) | (b[i + 2] & 63)
      );
      i += 2;
    }
  }
  return ret;
}

// Set the private key fields N, e, and d from hex strings
function RSASetPrivate(N, E, D) {
  if (N != null && E != null && N.length > 0 && E.length > 0) {
    this.n = parseBigInt(N, 16);
    this.e = parseInt(E, 16);
    this.d = parseBigInt(D, 16);
  } else console.log("Invalid RSA private key");
}

function RSASetPrivateCert(cert) {
  var key = new NodeRSA();
  key.importKey(cert);

  var N = key.keyPair.n.toString(16);
  var E = key.keyPair.e.toString(16);
  var D = key.keyPair.d.toString(16);

  if (N % 2 == 1) {
    N = "0" + N; // pad them with 0
  }
  if (N != null && E != null && N.length > 0 && E.length > 0) {
    this.n = parseBigInt(N, 16);
    this.e = parseInt(E, 16);
    this.d = parseBigInt(D, 16);
  } else console.log("Invalid RSA private key");

  //return this.setPrivate(exportObj.n, exportObj.e);
}

// Set the private key fields N, e, d and CRT params from hex strings
function RSASetPrivateEx(N, E, D, P, Q, DP, DQ, C) {
  var params = {};
  if (typeof N == "object") {
    params = N;
  } else {
    params.n = N;
    params.e = E;
    params.d = D;
    params.p = P;
    params.q = Q;
    params.dmp1 = DP;
    params.dmq1 = DQ;
    params.coeff = C;
  }
  if (
    params.n != null &&
    params.e != null &&
    params.n.length > 0 &&
    params.e.length > 0
  ) {
    this.n = parseBigInt(params.n, 16);
    this.e = parseInt(params.e, 16);
    this.d = parseBigInt(params.d, 16);
    this.p = parseBigInt(params.p, 16);
    this.q = parseBigInt(params.q, 16);
    this.dmp1 = parseBigInt(params.dmp1, 16);
    this.dmq1 = parseBigInt(params.dmq1, 16);
    this.coeff = parseBigInt(params.coeff, 16);
  } else console.log("Invalid RSA private key");
}

// Generate a new random private key B bits long, using public expt E
function RSAGenerate(B, E) {
  var rng = new SecureRandom();
  var qs = B >> 1;
  this.e = parseInt(E, 16);
  var ee = new BigInteger(E, 16);
  for (;;) {
    for (;;) {
      this.p = new BigInteger(B - qs, 1, rng);
      if (
        this.p
          .subtract(BigInteger.ONE)
          .gcd(ee)
          .compareTo(BigInteger.ONE) == 0 &&
        this.p.isProbablePrime(10)
      )
        break;
    }
    for (;;) {
      this.q = new BigInteger(qs, 1, rng);
      if (
        this.q
          .subtract(BigInteger.ONE)
          .gcd(ee)
          .compareTo(BigInteger.ONE) == 0 &&
        this.q.isProbablePrime(10)
      )
        break;
    }
    if (this.p.compareTo(this.q) <= 0) {
      var t = this.p;
      this.p = this.q;
      this.q = t;
    }
    var p1 = this.p.subtract(BigInteger.ONE);
    var q1 = this.q.subtract(BigInteger.ONE);
    var phi = p1.multiply(q1);
    if (phi.gcd(ee).compareTo(BigInteger.ONE) == 0) {
      this.n = this.p.multiply(this.q);
      this.d = ee.modInverse(phi);
      this.dmp1 = this.d.mod(p1);
      this.dmq1 = this.d.mod(q1);
      this.coeff = this.q.modInverse(this.p);
      break;
    }
  }
}

// Perform raw private operation on "x": return x^d (mod n)
function RSADoPrivate(x) {
  if (this.p == null || this.q == null) return x.modPow(this.d, this.n);

  // TODO: re-calculate any missing CRT params
  var xp = x.mod(this.p).modPow(this.dmp1, this.p);
  var xq = x.mod(this.q).modPow(this.dmq1, this.q);

  while (xp.compareTo(xq) < 0) xp = xp.add(this.p);
  return xp
    .subtract(xq)
    .multiply(this.coeff)
    .mod(this.p)
    .multiply(this.q)
    .add(xq);
}

// Return the PKCS#1 RSA decryption of "ctext".
// "ctext" is an even-length hex string and the output is a plain string.
function RSADecrypt(ctext) {
  var hex = b642hex(ctext);
  var c = parseBigInt(hex, 16);
  var m = this.doPrivate(c);
  if (m == null) return null;
  var final = pkcs1unpad2(m, (this.n.bitLength() + 7) >> 3);
  return final;
}

function b642hex(s) {
  var b64map =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
  var b64pad = "=";

  var ret = "";
  var i;
  var k = 0; // b64 state, 0-3
  var slop;
  for (i = 0; i < s.length; ++i) {
    if (s.charAt(i) == b64pad) break;
    var v = b64map.indexOf(s.charAt(i));
    if (v < 0) continue;
    if (k == 0) {
      ret += int2char(v >> 2);
      slop = v & 3;
      k = 1;
    } else if (k == 1) {
      ret += int2char((slop << 2) | (v >> 4));
      slop = v & 0xf;
      k = 2;
    } else if (k == 2) {
      ret += int2char(slop);
      ret += int2char(v >> 2);
      slop = v & 3;
      k = 3;
    } else {
      ret += int2char((slop << 2) | (v >> 4));
      ret += int2char(v & 0xf);
      k = 0;
    }
  }
  if (k == 1) ret += int2char(slop << 2);
  return ret;
}

function int2char(n) {
  var BI_RM = "0123456789abcdefghijklmnopqrstuvwxyz";
  return BI_RM.charAt(n);
}

// Return the PKCS#1 RSA decryption of "ctext".
// "ctext" is an even-length hex string and the output is a plain string.
function RSADecryptPublic(ctext) {
  var c = parseBigInt(ctext, 16);
  var m = this.doPublic(c);
  if (m == null) return null;
  return pkcs1unpad2(m, (this.n.bitLength() + 7) >> 3);
}

// Return the PKCS#1 RSA decryption of "ctext".
// "ctext" is a Base64-encoded string and the output is a plain string.
//function RSAB64Decrypt(ctext) {
//  var h = b64tohex(ctext);
//  if(h) return this.decrypt(h); else return null;
//}

// protected
RSAKey.prototype.doPrivate = RSADoPrivate;

// public
RSAKey.prototype.setPrivate = RSASetPrivate;
RSAKey.prototype.setPrivateEx = RSASetPrivateEx;
RSAKey.prototype.setPrivateCert = RSASetPrivateCert;
RSAKey.prototype.generate = RSAGenerate;
RSAKey.prototype.decrypt = RSADecrypt;
RSAKey.prototype.decryptPublic = RSADecryptPublic;
RSAKey.prototype.getPublicString = RSAGetPublicString;
RSAKey.prototype.setPublicCert = RSASetPublicCert;
RSAKey.prototype.setPublicString = RSASetPublicString;
RSAKey.prototype.getPrivateString = RSAGetPrivateString;
RSAKey.prototype.setPrivateString = RSASetPrivateString;
RSAKey.prototype.linebrk = linebrk; // line break
//RSAKey.prototype.b64_decrypt = RSAB64Decrypt;

//module.exports = RSAKey;

export default RSAKey;